define('helperUser',['require','helperUser-getAnswer','helperUser-getMultipleChoiceSelectedOptionsCount','helperUser-customPoints','helperUser-customStorage'],function(require) {
    'use strict';

    var User = {
        getAnswer: require('helperUser-getAnswer'),
        getMultipleChoiceSelectedOptionsCount: require('helperUser-getMultipleChoiceSelectedOptionsCount'),
        customPoints: require('helperUser-customPoints'),
        customStorage: require('helperUser-customStorage')
    };

    return User;
});

